import Body from "./components/Body";

const App = () => {

  return (
    <>
    <Body></Body>
    </>
   
  );

};
export default App;
